export default "__VITE_ASSET__64f7da9a__"